module.exports = __webpack_public_path__ + "img/merezha-white.6a43109d.svg";